
const TicketResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	"success": true,
	"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"id": 0,
	"ticketNumber": "string",
	"contact": {
		"name": "string",
		"mobilePhone": "string"
	},
	"busID": "string",
	"company": "string",
	"operatingCompany": {
		"code": "string",
		"name": "string"
	},
	"boardingPoint": {
		"city": "string",
		"terminal": "string",
		"additionalInfo": {
			"city": {
				"id": "string",
				"name": "string",
				"englishName": "string"
			},
			"name": "string",
			"englishName": "string"
		}
	},
	"droppingPoint": {
		"city": "string",
		"terminal": "string",
		"additionalInfo": {
			"city": {
				"id": "string",
				"name": "string",
				"englishName": "string"
			},
			"name": "string",
			"englishName": "string"
		}
	},
	"busType": "string",
	"price": 0,
	"discount": 0,
	"departureDate": "string",
	"issueDate": "string",
	"passengers": [
		{
			"firstName": "string",
			"lastName": "string",
			"seatNumber": 0,
			"nationalCode": "string",
			"gender": 1
		}
	],
	"status": "string",
	"token": "string",
	"ticketCode": "string"
};
 

  export default TicketResponse;
  